module.exports = __webpack_public_path__ + "static/media/Benifits1.46ba3847.png";